<template>
  <div class="centers">
    <div class="ml30 mt30" style="line-height: 20px;height: 20px;font-size: 16px;">
      版本更新
    </div>
    <div class="main">
      <div class="shops">
        <div class="space-between pt20" v-for="(item,index) in list" :key="index">
          <div class="ml30" style="line-height: 40px;height: 40px;font-size: 15px;">{{ item.softVersion }}更新内容</div>
          <div style="line-height: 40px;height: 40px;font-size: 15px;">{{formatDate(item.releaseTime)}}</div>
          <el-link class="mr40" type="primary" @click="detailAction(item)">查看详情</el-link>
        </div>
      </div>
    </div>
    <edit-form ref="editSetForm" @handleChange="changePage"></edit-form>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import editForm from './edit-form'
export default {
  mixins: [minxin],
  components: {},
  data() {
    return {
      appInfo: this.$store.getters.AppInfo,
      url: this.$url.versionManage.list,
      query: {
        versionPlatformType: 'app',
        status: 'enable',
        size: '3',
        start: '1',
      },
      list: [],
      menuInfo: []
    };
  },
  // mixins: [minxin],
  components: { editForm },
  computed: {},

  created() {
    this.init();
  },
  methods: {
    init() {
      this.$api.post(this.$url.versionManage.list, this.query).then(res => {
        this.list = res;
      }).catch(error => {});
    },
    totalCounts () {

    },
    detailAction(row) {
      this.$refs["editSetForm"].$emit("set",row);
    },
    changePage () {

    },
  }
};
</script>

<style lang="less" scoped>
.centers {
  font-size: 0.16rem;
  height: 100%;
  .head {
    display: flex;
    padding: 0 30px;
    align-items: center;
    justify-content: space-between;
    height: 70px;
    background: #2e334f;
    .logo-img {
      width: 144px;
      height: 47px;
    }
  }
  .main {
    padding: 16px;
    height: calc(100% - 70px);
    // background: #eeeeee;
    box-sizing: border-box;
    .shops {
      height: 100%;
      background: #fff;
      box-shadow: 0px 0px 14px 0px rgba(6, 0, 1, 0.1);
      border-radius: 4px;
      /deep/ .title {
        height: 60px;
        font-size: 20px;
        line-height: 60px;
      }
    
    }
  }
}
</style>